import React, { useContext } from 'react';
import { OnlineStatusContext } from '../../context/OnlineStatusContext';
import { timeAgo } from '../../utils/helpers';

/**
 * LastActive component displays user's last active status
 * Shows "Online now" for currently online users, otherwise shows relative time
 *
 * Strategy for accurate presence:
 * - Prefer recent activity (lastActive within ACTIVE_WINDOW_MS)
 * - Use real-time socket map
 * - Only fall back to persisted member.online if lastActive is unknown
 */
// Active window: 30 seconds - matches backend notification service
// Users are shown as online if they're connected OR were active within last 30 seconds
const ACTIVE_WINDOW_SECONDS = 30;
const ACTIVE_WINDOW_MS = ACTIVE_WINDOW_SECONDS * 1000;

const LastActive = ({ member, className = '', showOnlineStatus = true }) => {
  const onlineUsers = useContext(OnlineStatusContext) || {};

  if (!member) return null;

  const lastActiveTs = member.lastActive ? new Date(member.lastActive).getTime() : null;
  const isActiveByRecency = lastActiveTs ? (Date.now() - lastActiveTs) < ACTIVE_WINDOW_MS : false;
  const isOnlineSocket = onlineUsers[member._id] === true;
  const isOnlinePersisted = member.online === true;

  // Stricter rule: recency or socket decide; use persisted only if no lastActive available
  const isOnline = (isOnlineSocket || isActiveByRecency) || (!member.lastActive && isOnlinePersisted);

  if (showOnlineStatus && isOnline) {
    return (
      <span className={`last-active online-now ${className}`}>
        Online now
      </span>
    );
  }

  if (!member.lastActive) {
    return (
      <span className={`last-active no-activity ${className}`}>
        No recent activity
      </span>
    );
  }

  const lastActiveText = timeAgo(member.lastActive);

  return (
    <span className={`last-active ${className}`}>
      Last active {lastActiveText}
    </span>
  );
};

export default LastActive;
